import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/analytics";
import "firebase/storage";

const config = {
  apiKey: "AIzaSyCOVMADVk9Od6H1iJqhjr-2TJlfosQF0P0",
  authDomain: "comments-e9103.firebaseapp.com",
  projectId: "comments-e9103",
  storageBucket: "comments-e9103.appspot.com",
  messagingSenderId: "633536038721",
  appId: "1:633536038721:web:c87140f77324c44e1fc3c0",
  measurementId: "G-1Z3ZYGTBWK",
};

firebase.initializeApp(config);
firebase.analytics();

export const auth = firebase.auth();
export const firestore = firebase.firestore();
export const storage = firebase.storage();

const provider = new firebase.auth.GoogleAuthProvider();

export const signInWithGoogle = (token = null) => {
  if (token) {
    let credential = firebase.auth.GoogleAuthProvider.credential(null, token);
    auth.signInWithCredential(credential);
  } else {
    auth.signInWithPopup(provider);
  }
};

export const logout = (onSuccess, onError) => {
  firebase.auth().signOut().then(onSuccess, onError);
};

export const onAuthStateChanged = (callback) => {
  return firebase.auth().onAuthStateChanged((userAuth) => {
    if (userAuth) {
      firestore
        .collection("users")
        .doc(userAuth?.uid)
        .onSnapshot((doc) => {
          if (doc.data()) {
            callback({ ...doc.data(), ...userAuth });
          } else {
            callback({ ...userAuth });
          }
        });
    } else {
      callback(null);
    }
  });
};

export { firebase };
